import { createContext, useState, useContext, useMemo } from "react";
import { Language } from "../services/LanguageService";
import { getAccessTokenLocalStorage, ValidAccessTokenLocalStorage, handleUserLogOutErro } from "../context/utils"
import { UserPreferenceContext } from "../context/UserPreferenceContext";
import PropTypes from 'prop-types';

export const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState();
    const { userAuthenticated, setUserAuthenticated ,setUserMenssageApi} = useContext(UserPreferenceContext);

    async function doLanguage() {
        let token = getAccessTokenLocalStorage();
        if (ValidAccessTokenLocalStorage()) {
            await Language(token
            ).then(res => {
                setLanguage(res.data);
            })
                .catch(err => {
                    handleUserLogOutErro(err, userAuthenticated, setUserAuthenticated, setUserMenssageApi);
                });
        }
    };
    const value = useMemo(() => ({
        language,
        doLanguage,
    }), [language]); 
    return (
        <LanguageContext.Provider
            value={ value }
        >
            {children}
        </LanguageContext.Provider>
    );
}
LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default LanguageProvider;